<template>
  <el-dialog :title="$t('text.contactUpdateInformation')"
             :visible.sync="dialogShow"
             :close-on-click-modal="false"
             :originalContact="originalContact"
             @close="closeDialog"
             @open="openDialog">
    <el-form :model="form" ref="form">
      <el-form-item :label="$t('text.contactOldDetails')"
                    :label-width="formLabelWidth">
        <div style="text-align: left;font-size: 20px">{{this.originalContact}}</div>
      </el-form-item>

      <el-form-item :label="$t('text.contactNewDetails')"
                    :label-width="formLabelWidth">
        <el-input
            type="text"
            v-model="form.newContact"
            autocomplete="off"
            :placeholder="$t('message.inputContact')"/>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('text.cancel') }}</el-button>
      <el-button type="primary" @click="updateContact">{{ $t('text.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    show: Boolean,
    formData: Object,
    action: String,
    originalContact: String,
  },
  data() {
    return {
      dialogShow: this.show,
      form: {
        newContact: '',
        UpdateConfigName: 'constantConfig',
      },
      formLabelWidth: '200px',
    }
  },
  methods: {
    openDialog() {
    },
    closeDialog() {
      this.dialogShow = false
      this.$refs['form'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },
    updateContact() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let newContact = this.form.newContact
          const parameters = {
            contact: newContact
          };
          const parametersJson = JSON.stringify(parameters);

          this.axios
              .put('/config/update', {
                configName: this.form.UpdateConfigName,
                parameters: parametersJson,
              })
              .then(res => {
                if (res.code === 200) {
                  this.$notify({
                    title: this.$t('text.success'),
                    message: res.msg,
                    type: 'success',
                  })
                  this.closeDialog();
                  location.reload();
                } else {
                  this.$notify.error({
                    title: this.$t('text.error'),
                    message: res.msg,
                  })
                }
              })
        } else {
          return false
        }
      })
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal
    },
  },
}
</script>

<style scoped>
</style>